"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDongAddressName = exports.getDoSiDongAddress = exports.getRegionName = exports.FOUR_DEPTH_ADDRESSES = exports.METROPOLISES = void 0;
exports.METROPOLISES = [
    '세종시',
    '세종특별자치시',
    '광주시',
    '광주광역시',
    '인천시',
    '인천광역시',
    '부산시',
    '부산광역시',
    '대전시',
    '대전광역시',
    '대구시',
    '대구광역시',
    '울산시',
    '울산광역시',
    '서울시',
    '서울특별시',
];
/**
 * https://oss.navercorp.com/place/local/issues/6965
 */
exports.FOUR_DEPTH_ADDRESSES = [
    '성남시',
    '안양시',
    '용인시',
    '고양시',
    '안산시',
    '수원시',
    '전주시',
    '포항시',
    '창원시',
    '청주시',
    '천안시',
];
/**
 * @returns 주소 축약형 표기
 * https://oss.navercorp.com/place/local/issues/8246
 */
const getRegionName = (address) => {
    const [시도, 시군구, 구읍면동_도로명, 동리] = address.split(' ');
    if (exports.METROPOLISES.includes(시도)) {
        return `${시도.replace(/광역|특별자치|특별/g, '')} ${구읍면동_도로명 || ''}`;
    }
    if (exports.FOUR_DEPTH_ADDRESSES.includes(시군구)) {
        return `${시군구} ${동리 || 구읍면동_도로명}`;
    }
    if (시군구 || 구읍면동_도로명) {
        return `${시군구} ${구읍면동_도로명}`;
    }
    return address;
};
exports.getRegionName = getRegionName;
// https://oss.navercorp.com/bizServiceLab/sogum-next/issues/235#issue-281787
const shortAddressNames = {
    서울특별시: '서울',
    인천광역시: '인천',
    대전광역시: '대전',
    광주광역시: '광주',
    대구광역시: '대구',
    울산광역시: '울산',
    부산광역시: '부산',
    경기도: '경기',
    강원도: '강원',
    강원특별자치도: '강원',
    충청북도: '충북',
    충청남도: '충남',
    전라북도: '전북',
    전라남도: '전남',
    경상북도: '경북',
    경상남도: '경남',
    제주특별자치도: '제주',
    세종특별자치시: '세종',
    전북특별자치도: '전북',
};
const siGunGuDongEupMyeonRegex = /.+?[시군구동읍면로]\d*?가?(?=$|\s)/;
const getDoSiDongAddress = (address) => {
    if (!address)
        return null;
    const addressArr = address.split(' ');
    const shortendFirstAddress = shortAddressNames[addressArr[0]] || addressArr[0];
    const newAddressArr = [shortendFirstAddress];
    addressArr.forEach((item, index) => {
        var _a;
        if (index === 0)
            return;
        if ((_a = item.match(siGunGuDongEupMyeonRegex)) === null || _a === void 0 ? void 0 : _a[0])
            newAddressArr.push(item);
    });
    return newAddressArr.join(' ');
};
exports.getDoSiDongAddress = getDoSiDongAddress;
/**
 * 주소에서 행정구역 '읍/면/동' 을 추출합니다.
 * '동'의 경우 법정동명이 '~동/로/가'로 끝나는 경우를 포함하여 추출합니다.
 * https://www.code.go.kr/stdcode/regCodeL.do
 * https://namu.wiki/w/법정동#s-5.2
 */
const getDongAddressName = (지번_주소) => {
    const regex = /([가-힣]+[0-9]?(읍|면|동|가|로)([0-9][가-힣])?)(?=\s|$)/; // match string ends with 읍/면/동/가/로 (w/ and w/o blank)
    const matches = 지번_주소.match(regex);
    return (matches === null || matches === void 0 ? void 0 : matches[0]) || null;
};
exports.getDongAddressName = getDongAddressName;
